export default {
  init() {
    // JavaScript to be fired on all pages
    $('.deedModal').click(function () {
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        800
      );
    });

    $(document).ready(function () {
      if ($.cookie('modal_shown') == null) {
        $.cookie('modal_shown', 'yes', { expires: 7, path: '/' });
        $('#signupModal').modal('show');
      }
    });

    var siteURL = 'https://vatherightway.staging.mysites.io';
    // var siteURL = 'http://localhost:3000/shergelb/';
    var ajaxURL = siteURL + '/wp-admin/admin-ajax.php';

    $('.p_item').click(function (event) {
      event.preventDefault();
      var post_id = $(this).data('id');
      $.ajax({
        type: 'POST',
        url: ajaxURL,
        data: { action: 'load-contract-content', post_id: post_id },
        success: function (response) {
          console.log(response);
          return false;
        },
      });
    });

    $('.testimonial-slider').slick({
      draggable: true,
      arrows: true,
      autoplay: true,
      dots: true,
      fade: true,
      speed: 1400,
      infinite: true,
      touchThreshold: 100,
      appendArrows: $('.quote-wrap .arrows'),
      prevArrow:
        '<span class="Slick-Prev"><i class="ion-ios-arrow-thin-left"></i></span>',
      nextArrow:
        '<span class="Slick-Next"><i class="ion-ios-arrow-thin-right"></i></span>',
    });

    // Speakout Headshots Slider
    $(function () {
      $('.slides_container .slide:first-child').addClass('active');
      var interval = 2000,
        active_slide = 0,
        dom_slides = $('.slides_container .slide'),
        num_slides = dom_slides.length;
      setInterval(function () {
        ++active_slide;
        if ((active_slide = active_slide % num_slides) < 0)
          active_slide += num_slides;
        dom_slides
          .removeClass('active')
          .eq(active_slide)
          .addClass('active');
      }, interval);
    });

    // PLEDGE SLIDES
    var images = [
      '../wp-content/themes/vets/dist/images/pledges/pledge-1.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-2.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-3.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-4.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-5.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-6.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-7.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-8.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-9.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-10.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-11.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-12.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-13.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-14.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-15.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-16.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-17.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-18.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-19.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-20.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-21.jpg',
      '../wp-content/themes/vets/dist/images/pledges/pledge-22.jpg',
    ];

    var i = 0;
    var allDivs = [];

    function changeBackground() {
      allDivs = $('.hexagon-in2').each(function () {
        // setBG($(this),1000);
        setBG($(this), 1000);
      });
    }

    function setBG(div, time) {
      var timeVar;
      clearTimeout(timeVar);

      if (div == undefined) {
        return;
      }
      div.html(function () {
        if (i >= images.length) {
          i = 0;
        }
        // return 'url(' + images[i++] + ')';
        return '<img src=' + images[i++] + 'class="img-responsive" />';
      });

      timeVar = setTimeout(setTimer, time);
    }

    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function setTimer() {
      var imageIndex = getRandomInt(0, allDivs.length);
      setBG($(allDivs[imageIndex]), 3000);
    }

    $(function () {
      changeBackground();
    });

    // new WOW({
    //   offset: 200, // distance to the element when triggering the animation (default is 0)
    //   mobile: false,
    // });
    // new WOW().init();

    $('.smoothscroll').click(function () {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 60,
        },
        800
      );
      return false;
    });

    $('.scrollDown').click(function () {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top,
        },
        800
      );
      return false;
    });

    $('.scrolltop').click(function () {
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        800
      );
    });

    (function () {
      $('.hamburger-menu').on('click', function () {
        $('.bar').toggleClass('animate');
        $('.nav-primary').toggleClass('active');
      });
    })();

    if ($(window).width() > 993) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 200) {
          $('.header').addClass('scrolled');
          // $('.brand-link').hide();
          // $('.home-link').fadeIn();
        } else {
          // $('.brand-link').show();
          $('.header').removeClass('scrolled');
          // $('.home-link').hide();
        }
      });

      $('.brand').hover(function () {
        if ($('.header').hasClass('scrolled')) {
          $('.header').toggleClass('scrolled');
        }
      });

      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 3600) {
          $('.first').addClass('active');
        } else {
          $('.first').removeClass('active');
        }
      });
    }

    /*
    $('.brand').hover(function(e) {
      e.stopPropagation();
      $('.navlinks').toggleClass('open');
    });
    */

    $('.banner').hover(function () {
      $('.navlinks').toggleClass('open');
    });

    //set active class to first slide
    $('.slider-nav .slick-slide').eq(0).addClass('slick-active');

    // $('.slider-nav').slick({
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   asNavFor: '.intro-slider',
    //   dots: false,
    //   centerMode: true,
    //   focusOnSelect: false,
    //   arrows: true,
    // });

    $('.slider-nav').on('click', '.slick-slide', function (e) {
      e.preventDefault();
      var $currTarget = $(e.currentTarget),
        index = $currTarget.data('slick-index'),
        slickObj = $('.intro-slider').slick('getSlick');
      slickObj.slickGoTo(index);
    });

    $('.reply-box').hide();
    $('.comment-toggle').click(function () {
      $('.reply-box').slideToggle();
    });

    // News Slider
    $('.SlickCarousel').slick({
      rtl: false, // If RTL Make it true & .slick-slide{float:right;}
      autoplay: false,
      infinite: false,
      speed: 800, // Transition Speed
      centerMode: false,
      slidesToShow: 3, // Number Of Carousel
      // centerPadding: '120px',
      slidesToScroll: 3, // Slide To Move
      pauseOnHover: false,
      appendArrows: $('.slider-wrap .arrows'), // Class For Arrows Buttons
      prevArrow:
        '<span class="Slick-Prev"><i class="ion-ios-arrow-thin-left"></i></span>',
      nextArrow:
        '<span class="Slick-Next"><i class="ion-ios-arrow-thin-right"></i></span>',
      easing: 'linear',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    var vimeoVideoID = '183763765';

    $('.video a').click(function (e) {
      e.preventDefault();
      $('.video-container').html(
        '<iframe src="https://player.vimeo.com/video/' +
        vimeoVideoID +
        '?title=1&amp;byline=1&amp;portrait=1&amp;autoplay=true" width="100%" height="100%" frameborder="0"></iframe>'
      );
      $('.video a').fadeOut();
    });

    $.getJSON(
      'https://www.vimeo.com/api/v2/video/' +
      vimeoVideoID +
      '.json?callback=?',
      { format: 'json' },
      function (data) {
        $('.thumbs').attr('src', data[0].thumbnail_large);
      }
    );

    var inviewItem = $('.inview-item');

    inviewItem.waypoint(
      function (direction) {
        if (direction === 'down') {
          $(this).addClass('inview');
        } else {
          $(this).removeClass('inview');
        }
      },
      {
        offset: '80%',
      }
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js